import React from 'react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className='bg-glory-blue-dark border-t border-glory-blue-dark/20 mt-16'>
      <div className='max-w-none mx-auto px-6 sm:px-8 lg:px-12 xl:px-16 py-8'>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8'>
          {/* Logo和基本信息区域 */}
          <div>
            <div className='flex items-center gap-3 mb-3'>
              <div className='w-8 h-8 bg-gradient-to-br from-glory-gold via-glory-gold-dark to-glory-gold rounded-lg flex items-center justify-center'>
                <span className='text-white font-bold text-lg'>Elo</span>
              </div>
              <h3 className='bg-gradient-to-r from-glory-gold via-glory-gold-light to-glory-gold bg-clip-text text-transparent font-bold text-lg'>
                王者ELO排名系统
              </h3>
            </div>
            <p className='text-gray-300 text-sm'>
              基于客观数据的王者荣耀职业选手实力评估平台
            </p>
          </div>

          {/* 必要链接区域 */}
          {/* <div className="flex flex-col sm:flex-row gap-4 md:justify-end">
            <nav className="flex flex-col sm:flex-row gap-4">
              <a 
                href="/about" 
                className="text-gray-300 hover:text-glory-gold-light transition-colors duration-200 text-sm"
              >
                数据说明
              </a>
              <a 
                href="/about#contact" 
                className="text-gray-300 hover:text-glory-gold-light transition-colors duration-200 text-sm"
              >
                联系我们
              </a>
            </nav>
          </div> */}
        </div>

        {/* 底部版权区域 */}
        <div className='border-t border-gray-600/20 mt-6 pt-4'>
          <div className='flex flex-col sm:flex-row justify-between items-center gap-2'>
            <div className='text-gray-400 text-xs'>
              © {currentYear} 王者ELO排名系统. 基于公开数据构建，仅供参考。
            </div>
            <div className='flex items-center gap-3 text-xs text-gray-400'>
              <span className='text-glory-gold-light font-medium'>v1.0</span>
              <span>·</span>
              <span>最后更新: {new Date().toLocaleDateString('zh-CN')}</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
